import Select from 'antd/es/select';

export default Select;
